import React from 'react';
import { useSelector } from 'react-redux';
import { MultilineText } from 'utils/renderMultilineText';
import styles from './ConfirmModal.module.scss';

export default function ConfirmModal({
  open,
  title,
  description,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  closeOnOverlay = false,
  cssStyle,
  maxCharsPerLine = 37,
  showCancelBtn = true,
}) {
  const assets = useSelector(state => state.asset);
  const closeIcon = assets?.Icono_Cerrar || '';

  if (!open) return null;

  return (
    <div
      className={cssStyle?.overlay || styles?.overlay}
      onClick={closeOnOverlay ? onCancel : undefined}
    >
      <div
        className={cssStyle?.modal || styles.modal}
        onClick={e => e.stopPropagation()}
      >
        <div className={cssStyle?.content_x || styles.content_x}>
          <button
            className={cssStyle?.closeBtn || styles.closeBtn}
            onClick={onCancel}
          >
            {closeIcon ? (
              <img
                className={cssStyle?.closeIcon || styles.closeIcon}
                src={closeIcon}
              />
            ) : (
              <span className={cssStyle?.closeIcon || styles.closeIcon} />
            )}
          </button>
        </div>

        <h2 className={cssStyle?.title || styles.title}>
          <MultilineText
            text={title}
            maxLines={2}
            maxCharsPerLine={maxCharsPerLine}
          />
        </h2>

        {description && (
          <p className={cssStyle?.description || styles.description}>
            {description}
          </p>
        )}

        <div className={styles.actions}>
          <button
            className={cssStyle?.confirmBtn || styles.confirmBtn}
            onClick={onConfirm}
          >
            {confirmText}
          </button>

          {showCancelBtn && (
            <button
              className={cssStyle?.cancelBtn || styles.cancelBtn}
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
